import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '../../classes/services/notification.service';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class ExceptionManager {
    private error500 = 'Se ha producido un error en el servidor. Vuelva a intentarlo más tarde';
    private error404 = 'Recurso no encontrado o no disponible';
    constructor(
        private spinnerService: SpinnerService,
        private notificationService: NotificationService,
    ) {}

    handleError(error: HttpErrorResponse) {
        // Server or connection error happened
        if (!navigator.onLine) {
            // Handle offline error
            this.notificationService.addErrorMessage('Se ha producido un error de conexión');
        } else {
            // Handle Http Error (error.status === 403, 404...)

            if (error.status == 400) {
                this.handleError400(error);
            } else {
                if (error.status == 500) {
                    let mensaje: string = error.error.substring(error.error.indexOf('<div class="titleerror">') + 24, error.error.indexOf('</div>'));
                    this.notificationService.addErrorMessage(`${error.status} - ${mensaje}`);
                } else this.notificationService.addErrorMessage(`${error.status} - ${error.message}`);
            }
        }
    }

    handleError400(error: any, clientCallback?: (key: string, field: string) => void | null) {
        this.spinnerService.hideSpinner();
        if (error?.error) {
            if (error.error instanceof Array) {
                for (let item of error.error) {
                    if (item.key != null) {
                        if (clientCallback) {
                            clientCallback(item.key, item.field);
                        }
                    } else {
                        this.notificationService.addErrorMessage(item.message);
                    }
                }
            } else {
                this.notificationService.addErrorMessage(error.error?.error);
            }
        } else if (error?.status === 404) {
            this.notificationService.addErrorMessage(this.error404);
        } else if (error?.status === 500) {
            this.notificationService.addErrorMessage(this.error500);
        } else {
            this.notificationService.addErrorMessage(`${error?.status || ''} - ${error?.message}`);
        }
    }
}
